import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/admin/portal-content/faq/:id
//
// Pessimistic. Invalidates portalContent.faqAdmin + portalContent.faqPublic.
export function useDeleteFaqItem() {
  const queryClient = useQueryClient();
  return useMutation<void, ApiClientError, { id: string }>({
    mutationFn: ({ id }) =>
      apiFetch<void>(`/admin/portal-content/faq/${encodeURIComponent(id)}`, {
        method: "DELETE",
      }),
    onError: (err) => {
      toast.error(err.message ?? "Failed to delete FAQ item");
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.portalContent.faqAdmin(),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.portalContent.faqPublic(),
      });
    },
  });
}
